import { selectorFamily } from 'recoil';
import { OnlineSales } from 'gw-edge-client';
import {
    type OPCTermDTO,
    type EditTermDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const getTermOPCInfoSelector = selectorFamily<OPCTermDTO | undefined, string>({
    key: 'getTermOPCInfo',
    get:
        (editTermDTO) =>
        async ({ get }) => {
            const { jobNumber, sessionId } = get(jobInfoAtom);
            return await OnlineSales.getTermOPCInfo(
                jobNumber,
                sessionId,
                JSON.parse(editTermDTO) as EditTermDTO
            ).catch(() => {
                return undefined;
            });
        }
});
